// src/pages/ListaComunicadosRector.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import socket from '../socket';
import '../style/ComunicadosTabla.css';

function ListaComunicadosRector() {
  const [comunicados, setComunicados] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [editId, setEditId] = useState(null);
  const [editTitulo, setEditTitulo] = useState('');
  const [editMensaje, setEditMensaje] = useState('');
  const [editDestinatario, setEditDestinatario] = useState('');
  const rolUsuario = localStorage.getItem('role');

  const cargarComunicados = async () => {
    try {
      const res = await axios.get('http://localhost:5001/api/comunicados');
      const filtrados = res.data.filter(c =>
        c.destinatario === 'todos' || c.destinatario === rolUsuario || rolUsuario === 'rector'
      );
      setComunicados(filtrados);
    } catch (error) {
      console.error('Error al obtener comunicados:', error);
    }
  };

  useEffect(() => {
    cargarComunicados();
    socket.on('nuevoComunicado', (nuevo) => {
      const visible = nuevo.destinatario === 'todos' || nuevo.destinatario === rolUsuario || rolUsuario === 'rector';
      if (visible) setComunicados(prev => [nuevo, ...prev]);
    });
    return () => socket.off('nuevoComunicado');
  }, []);

  const comunicadosFiltrados = comunicados.filter(c =>
    c.titulo.toLowerCase().includes(filtro.toLowerCase()) ||
    c.mensaje.toLowerCase().includes(filtro.toLowerCase()) ||
    (c.destinatario || '').toLowerCase().includes(filtro.toLowerCase())
  );

  const handleEliminar = async (id) => {
    await axios.delete(`http://localhost:5001/api/comunicados/${id}`);
    cargarComunicados();
  };

  const handleActualizar = (comunicado) => {
    setEditId(comunicado.id);
    setEditTitulo(comunicado.titulo);
    setEditMensaje(comunicado.mensaje);
    setEditDestinatario(comunicado.destinatario || '');
  };

  const handleGuardarActualizacion = async () => {
    await axios.put(`http://localhost:5001/api/comunicados/${editId}`, {
      titulo: editTitulo,
      mensaje: editMensaje,
      destinatario: editDestinatario
    });
    setEditId(null);
    cargarComunicados();
  };

  const handleAnular = async (id) => {
    await axios.put(`http://localhost:5001/api/comunicados/anular/${id}`);
    cargarComunicados();
  };

  return (
    <div className="tabla-comunicados-container">
      <h2>📋 Historial de Comunicados</h2>
      <input
        type="text"
        placeholder="Buscar por título, mensaje o destinatario..."
        value={filtro}
        onChange={(e) => setFiltro(e.target.value)}
        className="input-busqueda"
      />

      <table className="tabla-comunicados">
        <thead>
          <tr>
            <th>ID</th>
            <th>Título</th>
            <th>Mensaje</th>
            <th>Destinatario</th>
            <th>Fecha</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {comunicadosFiltrados.map((c) => (
            <tr key={c.id}>
              <td>{c.id}</td>
              <td>{c.titulo}</td>
              <td>{c.mensaje}</td>
              <td>{c.destinatario || '—'}</td>
              <td>{new Date(c.fecha).toLocaleString()}</td>
              <td>
                <button onClick={() => handleEliminar(c.id)}>Eliminar</button>
                <button onClick={() => handleActualizar(c)}>Actualizar</button>
                <button onClick={() => handleAnular(c.id)}>Anular</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editId && (
        <div className="modal-editar">
          <h3>Editar Comunicado</h3>
          <input
            type="text"
            value={editTitulo}
            onChange={e => setEditTitulo(e.target.value)}
            placeholder="Título"
          />
          <textarea
            value={editMensaje}
            onChange={e => setEditMensaje(e.target.value)}
            placeholder="Mensaje"
          />
          <input
            type="text"
            value={editDestinatario}
            onChange={e => setEditDestinatario(e.target.value)}
            placeholder="Destinatario"
          />
          <button onClick={handleGuardarActualizacion}>Guardar</button>
          <button onClick={() => setEditId(null)}>Cancelar</button>
        </div>
      )}

      {comunicadosFiltrados.length === 0 && (
        <p className="no-resultados">No se encontraron comunicados.</p>
      )}
    </div>
  );
}

export default ListaComunicadosRector;
